import React, { useEffect } from 'react';
import { useResponse } from 'services/hooks';
import ResultsButtonProps from './ResultsButton.props';
import { RESULTS_DISPLAY } from '../../constants';
import { AIGradientButton } from '../AIGradient';

const ResultsButton = ({ jsonResultsString, onClick }: ResultsButtonProps) => {
  const { errorNotification } = useResponse();

  useEffect(() => {
    try {
      JSON.parse(jsonResultsString);
    } catch (e) {
      errorNotification(RESULTS_DISPLAY.ERROR_PARSING_RESULTS);
    }
  }, [jsonResultsString, errorNotification]);

  return <AIGradientButton onClick={onClick}>{RESULTS_DISPLAY.BUTTON_CONTENT}</AIGradientButton>;
};

export default ResultsButton;
